import { NoStyleButton } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { PlayPauseButton } from "@aviary/components/InformationCarousel/BarNavigation/PlayPauseButton";
import { useDotNavigation } from "@aviary/components/NewCarousel/DotNavigation/useDotNavigation";
import type { EmblaCarouselType } from "@aviary/components/NewCarousel/emblaCarouselTypes";

import * as styles from "./VerticalDotNavigation.styles";

interface Props {
  emblaApi: EmblaCarouselType;
}

const VerticalDotNavigation = ({ emblaApi }: Props) => {
  const { t } = useTranslation();
  const { selectedIndex, scrollSnaps, onDotButtonClick, renderAriaLabel } =
    useDotNavigation(emblaApi);

  // autoplay.reset() restarts the timer only when playing; a paused carousel stays paused.
  const handleDotClick = (index: number) => {
    onDotButtonClick(index);
    emblaApi?.plugins()?.autoplay?.reset();
  };

  return (
    <div css={styles.wrapper}>
      <ul css={styles.dotList}>
        {scrollSnaps.map((_, index) => (
          <li key={index}>
            <NoStyleButton
              aria-label={t(renderAriaLabel(index))}
              customCss={[styles.dot.base, index === selectedIndex && styles.dot.selected]}
              onClick={() => handleDotClick(index)}
            />
          </li>
        ))}
      </ul>
      <PlayPauseButton emblaApi={emblaApi} intention="lightText" css={styles.playPauseButton} />
    </div>
  );
};

export { VerticalDotNavigation };
